export function formatVersionWithCode(version, code, fallback = '-') {
  const cleanedVersion = String(version || '').trim()
  const cleanedCode = String(code || '').trim()
  if (!cleanedVersion && !cleanedCode) return fallback
  if (!cleanedVersion) return cleanedCode
  if (!cleanedCode) return cleanedVersion
  return `${cleanedVersion} (code ${cleanedCode})`
}

